import React, { useState, useEffect } from 'react';


const TypingEffect = ({ texts, typingSpeed = 150, pauseTime = 1000 }) => {
    const [currentText, setCurrentText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [loop, setLoop] = useState(0);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const handleTyping = () => {
            const fullText = texts[loop % texts.length];
            const updatedText = isDeleting
                ? fullText.substring(0, currentText.length - 1)
                : fullText.substring(0, currentText.length + 1);

            setCurrentText(updatedText);

            if (!isDeleting && updatedText === fullText) {
                setTimeout(() => setIsDeleting(true), pauseTime);
            } else if (isDeleting && updatedText === '') {
                setIsDeleting(false);
                setLoop(loop + 1);
            }

            setIndex(index + 1);
        };

        const typingTimer = setTimeout(handleTyping, isDeleting ? typingSpeed / 2 : typingSpeed);

        return () => clearTimeout(typingTimer);
    }, [currentText, isDeleting, loop, texts, typingSpeed, pauseTime]);

    return (
        <h1>I'm <span className="typing-effect">{currentText}</span></h1>
    );
};

export default TypingEffect;
